import { Button, IconArrowInbox } from '@sequencehq/core-components'
import { ExportWaterfallReportModal } from './exportWaterfallReport.modal'
import { WATERFALL_EXPORT_COPY } from './waterfallExport.constants'
import type { RevenueWaterfallQueryParams } from './RevenueWaterfallTable/types'

type Props = {
  filters: RevenueWaterfallQueryParams
}

export const RevenueWaterfallExportToCsv = ({ filters }: Props) => {
  const exportButton = (
    <Button
      variant="secondary"
      leadingIcon={<IconArrowInbox />}
      aria-label={WATERFALL_EXPORT_COPY.triggerAriaLabel}
      data-testid="revrec.waterfall.exportCsv"
    >
      {WATERFALL_EXPORT_COPY.triggerLabel}
    </Button>
  )

  return <ExportWaterfallReportModal trigger={exportButton} filters={filters} />
}
